import React from 'react';
import cx from 'classnames';
import NextLink from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  external: {
    textDecoration: 'none',
    cursor: 'pointer',
  },
  link: {
    textDecoration: props => props.underline && 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: props => props.hoverColor && props.hoverColor,
    },
  },
}));

export const External = React.forwardRef(({ className, ...props }, ref) => {
  const classes = useStyles(props);
  return <a className={cx(classes.external, className)} {...props} ref={ref} />;
});

const Link = props => {
  const { href, as, underline, hover, hoverColor, ...restProps } = props;
  const classes = useStyles(props);
  return (
    <NextLink href={href} as={as} passHref>
      <Typography
        component={External}
        className={classes.link}
        {...restProps}
      />
    </NextLink>
  );
};

Link.defaultProps = {
  as: '',
  href: '',
  underline: false,
};

export default Link;
